module.exports = __webpack_public_path__ + "static/img/4.026cb7a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/4.jpeg
// module id = dNKk
// module chunks = 3